import React from 'react'
import { Helmet } from 'react-helmet'
import styled from '@emotion/styled'

import I18n from '../i18n'

import backgroundImage from './assets/ooh-marketing-hero.webp'
import dataImage from './assets/ooh-marketing-data.webp'
import extraImage from './assets/ooh-marketing-extra.webp'

import Button from '../components/Button'
import Section from '../components/Section'
import Headline from '../components/Headline'
import Spacer from '../components/Spacer'

import DataSection from '../sections/DataSection'
import TwoColumnHeadlineText from '../sections/TwoColumnHeadlineText'
import TripleInfoBox from '../sections/TripleInfoBox'
import Testimonials from '../sections/Testimonials'
import Contact from '../sections/Contact'
import WhitePaperContact from '../sections/WhitePaperContact'

function LandingOohMarketing() {
  return (
    <div>
      <Helmet>
        <title>{I18n.t('pages.landing.ooh_marketing.title')}</title>
      </Helmet>

      <Top light>
        <Section.Skew inset position="bottom" light />
      </Top>

      <Section.Wrapper>
        <HeadlineWrapper>
          <CustomHeadline>
            {I18n.t('pages.landing.ooh_marketing.headline')}
          </CustomHeadline>
        </HeadlineWrapper>
        <TwoColumnHeadlineText
          headingLeft={I18n.t(
            'pages.landing.ooh_marketing.two_column.headline_left'
          )}
          contentLeft={'pages.landing.ooh_marketing.two_column.content_left'}
          contentRight={'pages.landing.ooh_marketing.two_column.content_right'}
        />
        <ButtonWrapper>
          <Button.Link href="#whitepaper_form">
            {I18n.t('pages.landing.ooh_marketing.button.download_white_paper')}
          </Button.Link>
        </ButtonWrapper>
      </Section.Wrapper>

      <DataSection
        image={dataImage}
        headline={'pages.landing.ooh_marketing.data_section.headline'}
        content={'pages.landing.ooh_marketing.data_section.content'}
        buttonText={'pages.landing.ooh_marketing.button.download_white_paper'}
        buttonLink={'#whitepaper_form'}
        clipPathColor={'#ffffff'}
        backgroundColor={'#f4f5f8'}
      />

      <TripleInfoBox
        headline={'pages.landing.ooh_marketing.triple_info_box.headline'}
        hasIcons={false}
        contentLeft={'pages.landing.ooh_marketing.triple_info_box.content_left'}
        contentMid={'pages.landing.ooh_marketing.triple_info_box.content_mid'}
        contentRight={
          'pages.landing.ooh_marketing.triple_info_box.content_right'
        }
        backgroundColor={'#ffffff'}
      />

      <ExtraImage />

      <Testimonials />

      <Section.Wrapper>
        <HeadlineWrapper>
          <CustomHeadline style={{ marginTop: '6.25rem' }}>
            {I18n.t('pages.landing.ooh_marketing.who_are_we.headline')}
          </CustomHeadline>
        </HeadlineWrapper>
        <TwoColumnHeadlineText
          headingLeft={I18n.t(
            'pages.landing.ooh_marketing.who_are_we.two_column.headline_left'
          )}
          headingRight={I18n.t(
            'pages.landing.ooh_marketing.who_are_we.two_column.headline_right'
          )}
          contentLeft={
            'pages.landing.ooh_marketing.who_are_we.two_column.content_left'
          }
          contentRight={
            'pages.landing.ooh_marketing.who_are_we.two_column.content_right'
          }
        />
        <Spacer size="3.25rem" transparent />
      </Section.Wrapper>

      <WhitepaperWrapper>
        <Section.Wrapper>
          <WhitePaperContact textPreSource="pages.landing.ooh_marketing" />
        </Section.Wrapper>
      </WhitepaperWrapper>

      <Spacer size="10rem" mid />

      <Contact
        teaser="pages.landing.ooh_marketing.contact.teaser"
        cta="pages.landing.ooh_marketing.contact.cta"
        styleOverrides={{
          marginBottom: '0'
        }}
      />
    </div>
  )
}

const Top = styled.div`
  position: relative;
  aspect-ratio: 2.5;
  background-image: url(${backgroundImage});
  background-repeat: no-repeat;
  background-position: left center;
  background-size: cover;

  ${props => props.theme.breakpoints.phone} {
    display: none;
  }
`

const CustomHeadline = styled(Headline)`
  font-size: 2.5rem !important;
`

const HeadlineWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  margin: 3rem 0;
`

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 4.75rem;

  a {
    font-size: 1rem;
  }
`

const WhitepaperWrapper = styled.div`
  background-color: #f4f5f8;
`

const ExtraImage = styled.div`
  width: 100%;
  aspect-ratio: 2.6;
  background-image: url(${extraImage});
  background-repeat: no-repeat;
  background-size: cover;
`

export default LandingOohMarketing
